<template>
  <div class="guest-camera">
    <!-- <h4 class="camera-title">Misafir Kamerası</h4> -->

    <div class="camera-container">
      <!-- <div v-if="hasGuest" class="camera-feed"> -->
      <div class="camera-placeholder">
        <!-- <i class="fas fa-user camera-icon"></i> -->
        <!-- <p class="camera-text">Guest User</p>
          <p class="camera-subtext">Connected</p> -->
        <!-- <video autoplay playsinline ref="vp" /> -->
        <slot name="video" />
      </div>

      <div class="guest-info">
        <span class="guest-name">{{ guestName }}</span>
        <span class="connection-status" :class="{ online: guestOnline }">
          <i class="fas fa-circle"></i>
          {{ guestOnline ? "Online" : "Offline" }}
        </span>
      </div>
      <!-- </div> -->

      <!-- <div v-else class="no-guest"> -->
      <!-- <i class="fas fa-user-plus invite-icon"></i> -->
      <!-- <p class="invite-text">No guest connected</p> -->
      <!-- <button class="invite-btn" @click="inviteGuest">
          <i class="fas fa-share"></i>
          Invite Guest
        </button> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    guestOnline: {
      type: Boolean,
      default: false,
    },
    guestName: {
      type: String,
      default: "Guest User",
    },
  },
  name: "GuestCamera",
  data() {
    return {};
  },
  mounted() {
    // console.log("slots", this.);
    // console.log("refs", this.$refs.vpremote);
  },
};
</script>

<style scoped>
.guest-camera {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.camera-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.camera-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.camera-feed {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.camera-placeholder {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #000;
  border-radius: 8px;
  color: white;
  min-height: 120px;
  margin-bottom: 8px;
}

.camera-icon {
  font-size: 32px;
  margin-bottom: 8px;
  opacity: 0.7;
}

.camera-text {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

.camera-subtext {
  margin: 4px 0 0 0;
  font-size: 12px;
  opacity: 0.7;
}

.guest-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  font-size: 12px;
}

.guest-name {
  font-weight: 500;
  color: #333;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}

.connection-status.online {
  color: #28a745;
}

.connection-status i {
  font-size: 8px;
}

.no-guest {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
}

.invite-icon {
  font-size: 32px;
  color: #6c757d;
  margin-bottom: 12px;
  opacity: 0.7;
}

.invite-text {
  margin: 0 0 16px 0;
  color: #6c757d;
  font-size: 14px;
}

.invite-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid #007bff;
  border-radius: 6px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.invite-btn:hover {
  background-color: #0056b3;
}

.invite-btn i {
  font-size: 12px;
}

.mic-off-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  color: #dc3545;
  font-size: 14px;
  font-weight: 500;
}
.mic-off-icon {
  font-size: 18px;
  color: #dc3545;
}
.mic-off-text {
  color: #dc3545;
}
</style>
